import { LoadablePaint } from '@confluence/loadable';

export const ContentByLabelMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentByLabelMacro" */ '../src/ContentByLabelMacroRenderer.tsx'
			)
		).ContentByLabelMacroRenderer,
});
